import { render } from "./DispPrice.vue?vue&type=template&id=9c2427b6"
import script from "./DispPrice.vue?vue&type=script&lang=js"
export * from "./DispPrice.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataDisp/DispPrice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c2427b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c2427b6', __exports__)) {
    console.log('reload')
    api.reload('9c2427b6', __exports__)
  }
  
  module.hot.accept("./DispPrice.vue?vue&type=template&id=9c2427b6", () => {
    console.log('re-render')
    api.rerender('9c2427b6', render)
  })

}


export default __exports__